module.exports = __webpack_public_path__ + "img/pro-cartography.6d2dfb47.webp";